import { IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSound } from '../store/gameStore';
import type { RootState } from '../store/gameStore';
import SoundIcon from './icons/SoundIcon';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

export const SoundToggle = () => {
  const dispatch = useDispatch();
  const soundEnabled = useSelector((state: RootState) => state.game.soundEnabled);

  return (
    <IconButton
      onClick={() => dispatch(toggleSound())}
      sx={{
        position: 'absolute',
        top: 32,
        right: 32,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '2px solid',
        borderColor: 'primary.main',
        width: 56,
        height: 56,
        zIndex: 10,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.2)'
        }
      }}
    >
      {soundEnabled ? (
        <SoundIcon width={24} height={24} color="#ffffff" />
      ) : (
        <VolumeOffIcon sx={{ color: '#ffffff', fontSize: 24 }} />
      )}
    </IconButton>
  );
};